import { Named } from '../base/named';
import { DataFlowColumn, IBasedOnEntityRef } from './dataflowcolumn';
import  type { DataFlowStream } from 'app/model/dataflow/transformation';
import { DataFlowExpression } from '../dataflow/dataflowexpression';

export class ColumnReference  implements IBasedOnEntityRef {

    public isAmbiguous: boolean;
    public complexFieldPath: string;
    public dynamicPartitionColumn: DataFlowExpression;

    constructor(public column: DataFlowColumn, public inputStream?: DataFlowStream, public ownerStream?: DataFlowStream, public skipSerializableName?: boolean) {
    }


    public get entity(): DataFlowColumn {
        return this.column;
    }

    public get rootEntity(): DataFlowColumn {
        return this.column;
    }

    public get siblingEntities(): DataFlowColumn[] {
        return this.column.ownerTransformation.outputColumns();
    }

    public get name(): string {
        return this.isAmbiguous ? this.fullyQualifiedName : this.originalName;
    }

    public get rootColumnName(): string {
        return this.isAmbiguous ? this.fullyQualifiedRootColumnName : this.column?.name;
    }

    public get originalName(): string {
        return this.complexFieldPath || this.column?.name;
    }

    public get fullyQualifiedName(): string {
        return this.getFullyQualifiedName(this.originalName);
    }

    public get fullyQualifiedRootColumnName(): string {
        return this.getFullyQualifiedName(this.column?.name);
    }

    public get serializableName(): string {
        const name = this.skipSerializableName || this.complexFieldPath ? this.originalName : this.column.serializableColumnName;
        return this.isAmbiguous ? this.getFullyQualifiedName(name) : name;
    }

    public get owningStreamName(): string {
        return (this.ownerStream && this.ownerStream.qualifiedName) || (this.column.ownerTransformation as Named).name;
    }

    public toString(): string {
        return this.name;
    }

    private getFullyQualifiedName(columnName: string): string {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this.column.ownerTransformation.outputStreams.size > 1 || !!(this.column.ownerTransformation as any).flowlet)
            && this.owningStreamName) {
            return `${this.owningStreamName}@${columnName}`;
        }
        return this.getQualifiedName(columnName);
    }

    private getQualifiedName(columnName: string): string {
        return `${(this.column.ownerTransformation as Named).name}@${columnName}`;
    }
}
